import PropTypes from 'prop-types';
import React from 'react';
import ReportBox from '../barbersReport/reportBox';
import count from '../barbersReport/count';

const OtherSalesInfo = ({ report, shortCount, showGiftCards }) => {
  let data = [{
    title: 'Tips collected',
    amount: report.tipAmount,
  }, {
    title: 'Taxes collected',
    amount: report.taxAmount,
  }, {
    title: 'Gift Card Sold',
    amount: report.giftCardSold,
  }, {
    title: 'Discounts/Promos',
    amount: report.totalDiscount,
  }, {
    title: 'Cancelled',
    amount: report.canceledAmount,
    count: count(report.canceledAppointmentCount, shortCount),
  }, {
    title: 'No Shows',
    amount: report.noShowAmount,
    count: count(report.noShowAppointmentCount, shortCount),
  }];

  if (!showGiftCards) {
    data = data.filter(({ title }) => title !== 'Gift Card Sold');
  }

  const content = data.map((item, index) => (
    <ReportBox key={index} {...item} />
  ));

  return (
    <div className="layout u-mv-">{content}</div>
  );
};

OtherSalesInfo.propTypes = {
  report: PropTypes.object.isRequired,
  shortCount: PropTypes.bool,
  showGiftCards: PropTypes.bool.isRequired,
};

OtherSalesInfo.defaultProps = {
  shortCount: false,
};

export default OtherSalesInfo;
